import React from "react";

import { useQuery } from "@apollo/client";
import { GET_PRIVACY_POLICY } from "../../graphql/queries/policy.query";

import "./policy.style.css";

interface IPolicyProps {
  type: "quote" | "order" | "registration";
}
export default function Policy({ type }: IPolicyProps) {
  const [privacyPolicy, setPrivacyPolicy] = React.useState<any>();

  useQuery(GET_PRIVACY_POLICY, {
    variables: { type },
    onCompleted(data) {
      const actualData = data.getPrivacyPolicy.data;
      if (actualData) setPrivacyPolicy(actualData);
    },
  });

  return (
    <div className="privacy-policy-container">
      <p className="privacy-policy-title">{privacyPolicy?.title}</p>

      <div dangerouslySetInnerHTML={{ __html: privacyPolicy?.body }} />
    </div>
  );
}
